import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createVNode as _createVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "cart" }
const _hoisted_2 = { class: "cart__header" }
const _hoisted_3 = { class: "cart__header-text" }
const _hoisted_4 = { class: "cart__list" }
const _hoisted_5 = { class: "field" }
const _hoisted_6 = { class: "field" }
const _hoisted_7 = { class: "cart__bottom" }
const _hoisted_8 = { class: "cart__result" }

import { computed, onMounted, onUnmounted, ref } from "vue";
  import CartItem from "./CartItem.vue";
  import Input from "@/UI/Input.vue";
  import { priceFormat } from "@/helpers/priceFormat";
  import { eventBus } from "@/helpers/eventBus";
import { IProduct } from "@/models/models";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Cart',
  emits: ["onOpenResult", "onCloseDetail"],
  setup(__props, { emit: __emit }) {

  const emit = __emit;

  const onOpenResult = () => {
    emit("onOpenResult");
  };

  const basket = ref<Array<IProduct>>(JSON.parse(localStorage.getItem("basket") || "[]"));

  const onClear = () => {
    basket.value = [];

    localStorage.setItem("basket", JSON.stringify(basket.value));

    eventBus.emit("cart-clear", {});

    emit("onCloseDetail");
  };

  const model = ref({
    comment: "",
    time: "В течении двух суток",
  });

  const resultPrice = computed(() => {
    let sum = 0;

    basket.value.forEach((item) => {
      sum += item.count * item.basePrice;
    });

    return sum;
  });

  const updateCart = () => {
    basket.value = JSON.parse(localStorage.getItem("basket") || "[]");
    
    if (basket.value.length == 0) {
      emit("onCloseDetail");
    }
  };

  onMounted(() => {
    updateCart();
    eventBus.on("cart-updated", updateCart);
  });

  onUnmounted(() => {
    eventBus.off("cart-updated", updateCart);
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "cart__title" }, "Корзина", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, "К заказу " + _toDisplayString(basket.value.length) + " товаров", 1),
      _createElementVNode("button", {
        class: "cart__header-btn",
        onClick: onClear
      }, "Очистить")
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(basket.value, (item, idx) => {
        return (_openBlock(), _createBlock(CartItem, {
          data: item,
          onOnClear: onClear,
          key: idx
        }, null, 8, ["data"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(Input, {
        type: "text",
        placeholder: "Комментарий",
        modelValue: model.value.comment,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.value.comment) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(Input, {
        type: "text",
        placeholder: "Интервал доставки",
        modelValue: model.value.time,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model.value.time) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(priceFormat)(resultPrice.value)), 1),
      _createElementVNode("button", {
        class: "cart__btn btn btn--green",
        onClick: onOpenResult
      }, " Оформить ")
    ])
  ]))
}
}

})